import $ from 'jquery';
import NavigationCart from './NavigationCart';
import Tips from '../Tips';
/* ===============================================================
Woocommerce scripts
=============================================================== */
class WoocommerceProducts {
    constructor() {
        // Cart section woocommerce products
        this.cartButton = $(
            '.irantheme-woocommerce-products-item-add-to-cart-button',
        );
        this.filterAjaxSection = $(
            '.irantheme-woocommerce-ajax-categories-products-filter-item',
        );
        this.navigationCart = new NavigationCart();
        this.tip = new Tips();
        this.events();
    }

    events() {
        // Shopping bag icon click
        $(
            '.irantheme-woocommerce-products-item-options-list-li.shop .ajax_add_to_cart',
        ).on('click', (e) => {
            e.preventDefault();
            this.addToCartWithSpinner($(e.currentTarget));
        });
        // Cart section woocommerce products
        this.cartButton.on('click', (e) => {
            let current = e.target;
            if (e.target.tagName == 'I') {
                current = $(e.target).parent();
            }
            this.addToCart(current);
        });
        // Trigger filter ajax item
        this.filterAjaxSection.on('click', (e) => {
            let current = e.target;
            if (e.target.tagName == 'I') {
                current = $(e.target).parent();
            }
            this.filterAjaxTrigger(current);
        });
    }

    // Filter ajax trigger
    filterAjaxTrigger(button) {
        // Check current class has active class or no
        if ($(button).hasClass('active')) {
            return;
        }
        // Remove active class from all buttons
        $(button)
            .siblings(
                '.irantheme-woocommerce-ajax-categories-products-filter-item',
            )
            .removeClass('active');
        // Add active class to current button
        $(button).addClass('active');
        // Get parent wrapper
        let wrapper = $(button).parents(
            '.irantheme-woocommerce-products-wrapper',
        );
        // Get result wrapper
        let wrapperResult = $(wrapper).find(
            '.irantheme-woocommerce-ajax-categories-products-result',
        );
        // Get preloader
        let preloader = $(wrapper).find('.irantheme-preloader-abs');
        // Get filter type of current category
        let filterType = $(button).data('product-filter');
        // Get filter data of current category
        let filterData = $(button).data('filter-item');
        // Get filter data all from current category
        let filterDataAll = '';
        // Get product number
        let productNumber = $(button).data('product-number');
        // Get product options
        let productOptions = $(wrapper).data('product-options');
        // Check filter all data
        if (filterType == 'category' && filterData == 'all') {
            filterDataAll = $(button).data('filter-all');
        }

        // Get previous wrapper swiper height
        let wrapperHeight = $(wrapperResult).height();

        // Get admin ajax url
        var ajax_url = iranthemeWpData.adminAjax;
        // Product fetch =============================================
        $.ajax({
            url: ajax_url,
            type: 'post',
            data: {
                action: 'get_woocommerce_ajax_products',
                filter_type: filterType,
                filter_data: filterData,
                filter_data_all: filterDataAll,
                product_number: productNumber,
                product_options: productOptions,
            },
            dataType: 'html',
            beforeSend: (response) => {
                $(preloader).addClass('active');
                $(wrapperResult).css({
                    opacity: 0,
                    visibility: 'hidden',
                });
                $(wrapperResult).height(wrapperHeight);
                // $(wrapperResult).html('');
            },
            success: (response) => {
                $(wrapperResult).html(response);
            },
            complete: (response) => {
                setTimeout(() => {
                    $(wrapperResult).css('height', 'auto');
                    $(wrapperResult).css({
                        opacity: 1,
                        visibility: 'visible',
                    });
                    $(preloader).removeClass('active');
                }, 250);
            },
            error: (error) => {
                console.log(error.responseText);
            },
        });
    }

    // In your WoocommerceProducts class, add this method
    addToCartWithSpinner(button) {
        const self = this; // Store reference to the class instance
        const productId = $(button).data('product_id');
        const productUrl = $(button).attr('href');
        let bag = $(button).find('.irantheme-icon-bag');
        let spinner = $(button).find('.irantheme-animate-rotate');
        let check = $(button).find('.irantheme-icon-check');

        // Show spinner
        $(button).addClass('loading');

        // Make AJAX request
        $.ajax({
            url: productUrl,
            type: 'post',
            data: {
                'add-to-cart': productId,
                quantity: 1,
            },
            beforeSend: function (response) {
                $(bag).hide();
                $(spinner).show();
            },
            success: function (response) {
                $(spinner).hide();
                $(check).fadeIn();
                // Use self instead of this
                self.navigationCart.fetchCount();
                self.tip.createTip(
                    'success',
                    'با موفقیت به سبد خرید اضافه شد',
                    5000,
                    `<br><a href="${iranthemeWoo.shoppingCartUrl}">"مشاهده سبد خرید"</a>`,
                );

                // Reset after 2 seconds
                setTimeout(() => {
                    $(check).hide();
                    $(bag).show();
                }, 4000);
            },
            error: function () {
                $(spinner).hide();
                $(check).hide();
                $(bag).show();
                alert('خطا در افزودن به سبد خرید');
            },
        });
    }

    // Add to cart
    addToCart(button) {
        const self = this; // Store reference to the class instance
        const productId = $(button).data('product_id');
        const productUrl = $(button).attr('href');

        let cartPlus = $(button).find(
            '.irantheme-woocommerce-products-item-add-to-cart-button-plus',
        );
        let cartSuccess = $(button).find(
            '.irantheme-woocommerce-products-item-add-to-cart-button-success',
        );
        let cartSpinner = $(button).find('.irantheme-animate-rotate');

        // Make AJAX request
        $.ajax({
            url: productUrl,
            type: 'post',
            data: {
                'add-to-cart': productId,
                quantity: 1,
            },
            beforeSend: function (response) {
                cartPlus.hide();
                cartSpinner.addClass('active');
            },
            success: function (response) {
                cartSpinner.removeClass('active');
                cartSuccess.fadeIn();
                // Use self instead of this
                self.navigationCart.fetchCount();
                self.tip.createTip(
                    'success',
                    'با موفقیت به سبد خرید اضافه شد',
                    5000,
                    `<br><a href="${iranthemeWoo.shoppingCartUrl}">"مشاهده سبد خرید"</a>`,
                );

                // Reset after 2 seconds
                setTimeout(() => {
                    cartSuccess.hide();
                    cartPlus.show();
                }, 4000);
            },
            error: function () {
                $(cartSuccess).hide();
                $(cartSpinner).hide();
                $(cartPlus).show();
                alert('خطا در افزودن به سبد خرید');
            },
        });
    }
}

export default WoocommerceProducts;
